import { Icon } from "@scuf/common";

function MessageInfoComponent({message = '', height = '300px', }) {
    return <div 
    className='d-flex align-items-center'
        style={{ height: height, padding:'20px',
        textAlign:'center'}}>
        <div style={{marginRight:'auto', marginLeft:'auto'}}>
            <div>
                <Icon root='common' name='badge-info' exactSize={20} style={{marginBottom: '10px'}}></Icon>
            </div>
            <div>
                {message}           
            </div>        
        </div>
    </div>
}

export default MessageInfoComponent;